import { render, staticRenderFns } from "./MemberProfileWrapper.vue?vue&type=template&id=1802de90"
import script from "./MemberProfileWrapper.vue?vue&type=script&lang=js"
export * from "./MemberProfileWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports